module.exports = __webpack_public_path__ + "img/file-plus.33187087.svg";